enum EntityType {
  LINE_ITEM = 'lineitem',
  PLANS = 'plans',
  PACKAGE = 'package',
}

export default EntityType;
